import { FoodsTooltip, useFormBaseContext } from "@foodpilot/foods";
import CloudDoneOutlined from "@mui/icons-material/CloudDoneOutlined";
import LoopOutlined from "@mui/icons-material/LoopOutlined";
import WarningAmber from "@mui/icons-material/WarningAmber";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useQuestionnaireFormContext } from "src/components/QuestionnaireForm/context/useQuestionnaireForm";

export const RightSave = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { post } = useQuestionnaireFormContext();

    const completions = post?.completions.ssq;
    const _stats = ` ${completions?.answers ?? 0} / ${completions?.questions ?? 0}`;
    const stats = _stats.replaceAll(" ", "\u00A0");
    return (
        <Stack alignItems={{ xs: "end", sm: "center" }} width={"100%"}>
            <Stack flexDirection={"row"} gap={theme.spacing(1)} alignItems={{ xs: "end", sm: "center" }}>
                <SavingCloudStatus />
                <Typography
                    variant="body-medium"
                    sx={{
                        // Align with svg
                        position: "relative",
                        top: "2px",
                    }}
                    display={{ xs: "none", sm: "block" }}
                >
                    {t("questionnaire.automatic_saving", "Automatically saved")}
                </Typography>
            </Stack>
            <Stack
                flexDirection={"row"}
                gap={theme.spacing(1)}
                alignItems={"center"}
                display={{ xs: "none", sm: "block" }}
            >
                <Typography variant="body-medium">
                    {t("questionnaire.completed_responses", "Completed responses")}
                </Typography>
                <Typography variant="number-micro">{stats}</Typography>
            </Stack>
        </Stack>
    );
};

export const SavingCloudStatus = () => {
    const theme = useTheme();
    const { isSaving, textOptions, isError } = useFormBaseContext();

    const StateIcon =
        isSaving ? LoopOutlined
        : isError ? WarningAmber
        : CloudDoneOutlined;

    const loadingAnimation =
        isSaving ?
            {
                animation: "spin 1s linear infinite",
                "@keyframes spin": {
                    "0%": {
                        transform: "rotate(360deg)",
                    },
                    "100%": {
                        transform: "rotate(0deg)",
                    },
                },
            }
        :   {};

    const Icon = (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",

                padding: 1,

                width: "28px",
                height: "28px",
                backgroundColor:
                    isError ? theme.custom.red[50]
                    : isSaving ? theme.custom.dataviz.colorsWithExtra[13].variant[100]
                    : theme.custom.green[50],
                borderRadius: "4px",
            }}
        >
            <StateIcon
                sx={{
                    fontSize: "20px",
                    color:
                        isError ? theme.custom.red[600]
                        : isSaving ? theme.custom.dataviz.colorsWithExtra[13].main
                        : theme.custom.green[600],
                    ...loadingAnimation,
                }}
            />
        </Box>
    );

    const StatePopoverBody = (
        <Typography variant="small-bold">
            {isSaving ?
                textOptions.syncingMessage
            : isError ?
                textOptions.errorDefaultMessage
            :   textOptions.savingDefaultMessage}
        </Typography>
    );

    return <FoodsTooltip title={StatePopoverBody}>{Icon}</FoodsTooltip>;
};
